import { useState } from "react";
import { MessageCircle, X } from "lucide-react";

/**
 * Tawk.to placeholder widget — light theme.
 * Replace TAWKTO_PROPERTY_ID + WIDGET_ID with real values when ready.
 *
 * Typography rule: title navy, body pure black.
 */
export default function TawkToWidget() {
  const [open, setOpen] = useState(false);
  return (
    <div className="fixed bottom-6 left-6 z-40">
      {open && (
        <div
          data-testid="tawkto-placeholder-panel"
          className="mb-3 w-[280px] rounded-xl border border-brand-navy/10 bg-white p-4 shadow-2xl shadow-brand-navy/10"
        >
          <div className="flex items-start justify-between mb-2">
            <div className="text-[10px] tracking-[0.25em] uppercase text-brand-green font-bold">
              Live chat
            </div>
            <button
              onClick={() => setOpen(false)}
              className="text-black/50 hover:text-black"
              data-testid="tawkto-close-button"
              aria-label="Fermer le chat"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
          <div className="text-brand-navy text-sm font-bold mb-1">Bientôt disponible</div>
          <p className="text-xs text-black font-roboto leading-relaxed">
            Notre chat en direct (Tawk.to) sera activé au lancement. En attendant,
            contactez-nous via WhatsApp ou email.
          </p>
        </div>
      )}
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid="tawkto-toggle-button"
        className="flex items-center gap-2 px-4 h-12 rounded-full bg-white text-black text-sm font-semibold border border-brand-navy/15 hover:border-brand-navy/40 shadow-lg shadow-brand-navy/5 hover:shadow-xl hover:shadow-brand-navy/10 transition-all"
      >
        <MessageCircle className="h-5 w-5 text-brand-blue" />
        Chat
      </button>
    </div>
  );
}
